// Small shared form pieces used by the newer panels (homework, syllabus,
// accounts, library, visitors…) so they stay visually identical.
import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { getClasses } from '../api/client';

export const inputCls = 'border border-line rounded-s px-3 py-2 text-sm bg-paper-raised text-ink focus:outline-none focus:ring-2 focus:ring-transit';
export const thCls = 'px-4 py-2.5';
export const theadRowCls = 'text-left text-[11px] font-bold uppercase tracking-wider text-ink-soft bg-paper';

export function Field({ label, className = '', children }) {
  return (
    <label className={`flex flex-col gap-1 text-xs font-bold text-ink-soft ${className}`}>
      {label}
      {children}
    </label>
  );
}

// Success / error line. Messages starting with "Error" render red.
export function Msg({ msg, className = '' }) {
  if (!msg) return null;
  const bad = /^(Error|Failed)/.test(msg);
  return (
    <p className={`text-sm font-bold px-3 py-2 rounded-s w-fit ${bad ? 'bg-critical-tint text-critical' : 'bg-success-tint text-success'} ${className}`}>
      {msg}
    </p>
  );
}

export const errText = (err) => 'Error: ' + (err.response?.data?.error || err.message);

export function Modal({ title, onClose, children, width = 520 }) {
  return (
    <div className="fixed inset-0 z-[1400] bg-[rgba(16,27,34,0.55)] flex items-start justify-center overflow-y-auto p-4" onClick={onClose}>
      <div className="bg-paper-raised rounded-m shadow-2 w-full mt-12 mb-8" style={{ maxWidth: width }} onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3.5 border-b border-line-soft">
          <h4 className="font-display font-bold text-[15px] text-ink">{title}</h4>
          <button onClick={onClose} aria-label="Close" className="text-ink-soft hover:text-ink p-1"><X size={18} /></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

// Class <select>. Loads classes itself unless `classes` is passed.
export function ClassSelect({ value, onChange, classes: given, allowAll = false, allLabel = 'All classes', required = false }) {
  const [classes, setClasses] = useState(given || []);
  useEffect(() => { if (!given) getClasses().then(setClasses).catch(() => {}); }, [given]);
  const list = given || classes;
  return (
    <select className={inputCls} value={value} required={required} onChange={e => onChange(e.target.value)}>
      {allowAll ? <option value="">{allLabel}</option> : <option value="" disabled>Select class</option>}
      {list.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
    </select>
  );
}

export function EmptyRow({ cols, children }) {
  return <tr><td colSpan={cols} className="px-4 py-8 text-center text-ink-soft">{children}</td></tr>;
}
